import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { menusAvailableArray } from '../../utils/data/MenuData';

const SITE_URL = 'https://www.thetavistockhotelandinn.co.uk/';

// schema.org Menu markup so search engines can read dishes & prices
const buildMenuSchema = (menus) => ({
  '@context': 'https://schema.org',
  '@type': 'Menu',
  '@id': `${SITE_URL}#menu`,
  name: 'Main Menu',
  inLanguage: 'en-GB',
  hasMenuSection: menus.map((menu) => ({
    '@type': 'MenuSection',
    name: menu.title,
    hasMenuItem: menu.items.map((item) => ({
      '@type': 'MenuItem',
      name: item.name,
      ...(item.description && { description: item.description }),
      ...(item.price && {
        offers: {
          '@type': 'Offer',
          price: item.price.replace('£', ''),
          priceCurrency: 'GBP',
        },
      }),
    })),
  })),
});

const MenuComponent = () => {
  const [menus] = useState(menusAvailableArray);

  return (
    <section id='menu' className='bg-slate-700 py-16 px-6 md:px-20 text-center'>
      <Helmet>
        <script type='application/ld+json'>
          {JSON.stringify(buildMenuSchema(menus))}
        </script>
      </Helmet>

      <div className='container mx-auto'>
        <div className='py-4'>
          <h4 className='text-4xl md:text-5xl font-bold mb-6 text-white font-GaramondBold underline underline-offset-8'>
            Our Menu
          </h4>
          <p className='text-lg md:text-xl lg:text-2xl font-medium leading-relaxed mb-8 font-GaramondBold text-text-colour'>
            Discover our delicious selection of traditional British dishes.
          </p>
        </div>

        <section className='grid xl:grid-cols-2 xl:gap-4'>
          {menus.map((menu, index) => (
            <div
              key={index}
              className='menu-card main_bg p-6 rounded-lg shadow-md mb-10 relative overflow-hidden'
            >
              <h3 className='text-4xl font-bold mb-4 font-TangerineRegular'>
                {menu.title}
              </h3>

              <ul className='grid gap-4 text-left font-serif px-1 lg:px-2 pb-20'>
                {menu.items.map((item, idx) => (
                  <li key={idx} className='grid gap-1'>
                    <div className='grid grid-cols-[1fr_auto] gap-4 items-start'>
                      <span className='text-xl'>{item.name}</span>
                      {item.price ? (
                        <span className='text-xl whitespace-nowrap'>
                          {item.price}
                        </span>
                      ) : null}
                    </div>

                    {item.description ? (
                      <p className='text-base leading-relaxed opacity-90'>
                        {item.description}
                      </p>
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      </div>
    </section>
  );
};

export default MenuComponent;
